import { t } from "i18next";
import type { CountryCode } from "libphonenumber-js";
import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

export const addressSchema = z.object({
  googlePlaceId: z.string().min(1, "Address is required"),
  addressLine1: z.string().min(1, "Address line 1 is required"),
  name: z.string().min(1, "Name is required"),
  addressLine2: z.string(),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  country: z.string().min(1, "Country is required"),
  zipCode: z.string().min(1, "Postal code is required"),
  latitude: z.number(),
  longitude: z.number(),
});

export const phoneSchema = z
  .string()
  .min(1, { message: t("validation.required") })
  .refine(
    (value) => {
      const formatRegex = /^[A-Z]{2}-\d+-\d+$/;
      if (!formatRegex.test(value)) {
        return false;
      }

      const parts = value.split("-");
      if (parts.length !== 3) return false;

      const [countryCode, callNumber, phoneNumber] = parts;

      const fullPhoneNumber = `+${callNumber}${phoneNumber}`;

      return isValidPhoneNumber(fullPhoneNumber, countryCode as CountryCode);
    },
    {
      message: t("validation.phone_invalid"),
    },
  );
